export interface PricingJsonItem {
  Category: string;
  'Module Name'?: string;
  Details?: string;
  'Pay as you go'?: number | string;
}

export const PRICING_DATA: PricingJsonItem[] = [
  {
    Category: 'Visual Matching and Search',
    'Module Name': 'Image Matching',
    Details: 'Find the most fitting song segments to accompany image collections up to 7 images, with an optional prompt',
    'Pay as you go': 0.05
  },
  {
    Category: 'Visual Matching and Search',
    'Module Name': 'Video Matching',
    Details: 'Find the most fitting song segments to accompany videos, with an optional prompt',
    'Pay as you go': '$0.05 / min'
  },
  {
    Category: 'Visual Matching and Search',
    'Module Name': 'Prompt Search',
    Details: 'Use any text prompt to reflect your musical desires: lyrics, composition, song structure, writing style, sound and performance descriptors',
    'Pay as you go': 0.05
  },
  {
    Category: 'Visual Matching and Search',
    'Module Name': 'Artist/Song Similarity Search',
    Details: 'Name a reference song or artist to find similar songs, overall or for a specific prism: lyrics music, sound, or writing style',
    'Pay as you go': 0.05
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Add a song',
    'Pay as you go': 0.3
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Genre Detection',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Production Influences Detection',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Mood Detection',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Timbre',
    Details: 'Primarily Bright, Primarily Dark, Mixed',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Prominent Instruments',
    Details: 'All prominent instruments',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Tempo',
    Details: 'BPM',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Tempo Category',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Danceability',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Dynamic Range',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Primarily Acoustic vs Electronic',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Melodic Interval Prevalence',
    Details: '%P1-%m2, %M2-%m3, %M3-%P5, %m6+',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Main Melodic Range',
    Details: 'Vertical, Mixed-Vertical, Mixed-Horizontal, Horizontal',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Number of Melodic Themes',
    Details: 'Number',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Major/Major Mode vs. Minor/Minor Mode',
    Details: 'Major Mode = Lydian, Mixolydian, Blues, major\nMinor Mode = Dorian, Phrygian, Aeolian, Harmonic Minor, Melodic Minor, minor',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': '%Diatonic Chords',
    Details: 'Percent of chords',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Chord Repetition',
    Details: 'Number',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Use of Inverted Chords',
    Details: 'Percent of all chords',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Use of 7th Chords',
    Details: 'Percent of all chords',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Chord Degree Prevalence',
    Details: '%I, %II, %III, %IV, %V, %VI, %VII',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Main Melodic Range (tones)',
    Details: 'Number',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Key (Major, Minor, Major Mode, Minor Mode)',
    Details: 'Lydian, Mixolydian, Blues, Dorian, Phrygian, Aeolian, Harmonic Minor, Melodic Minor, Major, Minor',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Use of Parallel Mode',
    Details: '0/1',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Use of Triads',
    Details: 'Number',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Major 7th Prevalance',
    Details: 'Percent of all chords',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Use of Major 7th Chords',
    Details: 'Number',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Song Length',
    Details: 'Song Length (Minutes:Seconds)',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Song Length Category',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'First Section Type',
    Details: 'Intro, Verse, Chorus',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Verse Count',
    Details: 'Number of verses',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Pre-Chorus Count',
    Details: 'Number of Pre-Choruses',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Chorus Preceding Any Section',
    Details: '0/1',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Chorus Count',
    Details: 'Number of chorus repetitions',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Use Of A Bridge',
    Details: '0/1',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Last Section Type',
    Details: 'Outro, Chorus',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Song Form',
    Details: 'ABAB, AAA, Custom, AABAB, V-PC-CH (Non Standard), V-PC-CH, A-ch-A-ch-CP, A-ch-A-ch',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Pre-Chorus Section Lyrics',
    Details: 'Lyrically Identical\nNo Pre-Chorus\nLyrically Differentiated',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Intro Length',
    Details: 'Number',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Intro (Instrumental, Vocal)',
    Details: 'Instrumental, Vocal, No Intro',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Vocal Post-Chorus Count',
    Details: 'Number',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Departure Section',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Outro Length',
    Details: 'Number',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Outro (Instrumental, Vocal)',
    Details: 'Instrumental, Vocal, No Outro',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Number of Distinct Sections',
    Details: 'Number',
    'Pay as you go': 0.03
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Theme/Narrative',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Mood',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Main Language',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Song Title Appearances',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Overall Repetitiveness',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Lyrical Register',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Slang Usage',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Profanity Usage',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Rhyme Density',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'End Line Perfect Rhyme Density',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Sonic Fabric',
    'Pay as you go': 0.1
  },
  {
    Category: 'Song Analysis',
    'Module Name': 'Lyrical Specificty',
    Details: 'Locations, Names Persons, Organization or Brand References, Consumer Goods References, Creative Works Title References',
    'Pay as you go': 0.1
  }
]; 
